export default "__VITE_ASSET__c3ab6e30__"